// =============================================================================
// MeuDriver — Banner de boas-vindas para novos usuários (I3)
// =============================================================================

import { Link } from 'react-router-dom'
import { Sparkles, Search, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useState } from 'react'

interface WelcomeBannerProps {
  name?: string | null
}

export function WelcomeBanner({ name }: WelcomeBannerProps) {
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem('welcome_banner_dismissed') === '1'
  })

  if (dismissed) return null

  function handleDismiss() {
    localStorage.setItem('welcome_banner_dismissed', '1')
    setDismissed(true)
  }

  const firstName = name?.split(' ')[0] ?? 'aluno'

  return (
    <div className="relative overflow-hidden rounded-2xl border border-brand-200 bg-gradient-to-r from-brand-50 to-teal-50 p-5">
      {/* Decoração */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-brand-100 rounded-full -translate-y-1/2 translate-x-1/2 opacity-40 pointer-events-none" />

      <div className="relative flex items-start gap-4">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-100">
          <Sparkles className="h-5 w-5 text-brand-600" />
        </div>

        <div className="flex-1 min-w-0">
          <p className="font-bold text-gray-900 text-base">
            Bem-vindo ao MeuDriver, {firstName}!
          </p>
          <p className="text-sm text-muted-foreground mt-0.5 leading-relaxed">
            Encontre instrutores qualificados perto de você e agende sua primeira aula com facilidade.
          </p>
          <Button asChild size="sm" className="mt-3 bg-brand-600 hover:bg-brand-700 gap-1.5">
            <Link to="/instrutores">
              <Search className="h-3.5 w-3.5" />
              Buscar instrutor
            </Link>
          </Button>
        </div>

        <button
          type="button"
          onClick={handleDismiss}
          className="shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Fechar banner"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
